"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateSurveyQuestionRequestToJSON = exports.UpdateSurveyQuestionRequestFromJSONTyped = exports.UpdateSurveyQuestionRequestFromJSON = exports.instanceOfUpdateSurveyQuestionRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateSurveyQuestionRequest interface.
 */
function instanceOfUpdateSurveyQuestionRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateSurveyQuestionRequest = instanceOfUpdateSurveyQuestionRequest;
function UpdateSurveyQuestionRequestFromJSON(json) {
    return UpdateSurveyQuestionRequestFromJSONTyped(json, false);
}
exports.UpdateSurveyQuestionRequestFromJSON = UpdateSurveyQuestionRequestFromJSON;
function UpdateSurveyQuestionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'questionText': !(0, runtime_1.exists)(json, 'question_text') ? undefined : json['question_text'],
    };
}
exports.UpdateSurveyQuestionRequestFromJSONTyped = UpdateSurveyQuestionRequestFromJSONTyped;
function UpdateSurveyQuestionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'question_text': value.questionText,
    };
}
exports.UpdateSurveyQuestionRequestToJSON = UpdateSurveyQuestionRequestToJSON;
